import jwt from 'jsonwebtoken';

/**
 * Decodes a Google Sign-In id_token client-side to read basic profile
 * fields for pre-filling a form. This is a local, unverified decode - the
 * server independently verifies the token when it's actually submitted.
 * @param {string} idToken - the id_token from GoogleLogin's `credentialResponse.credential`.
 * @returns {{ email: string, givenName: string, familyName: string } | null}
 * Null if the token can't be decoded.
 */
const decodeGoogleIdToken = (idToken) => {
  try {
    const decoded = jwt.decode(idToken);
    if (!decoded) {
      return null;
    }
    return {
      email: decoded.email,
      familyName: decoded.family_name,
      givenName: decoded.given_name,
    };
  } catch (error) {
    return null;
  }
};

export default decodeGoogleIdToken;
